import UsesNotifications from './UsesNotifications'
export default {
  mixins: [UsesNotifications],
  methods: {
    callApiMetadataPatch(patch, successCallback, failCallback) {
      if (patch === null || patch === undefined) {
        this.showError('Failed to save, something went wrong.')
        return
      }
      this.$auth
        .getTokenSilently()
        .then((accessToken) => {
          this.$axios
            .put(this.$global.apiUrl + '/api/user/metadata', patch, {
              headers: { Authorization: 'Bearer ' + accessToken }
            })
            .then((response) => {
              // Refresh token
              this.$auth.getTokenSilently()
              this.appMetadata = response.data.appMetadata
              if (successCallback) {
                successCallback()
              }
            })
            .catch((e) => {
              this.showError('Failed to save, error calling API.')
              if (failCallback) {
                failCallback()
              }
            })
        })
        .catch(() => {
          this.showError('Failed to save, error getting auth token.')
          if (failCallback) {
            failCallback()
          }
        })
    },
    callApiUserMetadataPatch(patch, successCallback, failCallback) {
      if (patch === null || patch === undefined) {
        this.showError('Failed to save, something went wrong.')
        return
      }
      this.$auth
        .getTokenSilently()
        .then((accessToken) => {
          this.$axios
            .put(this.$global.apiUrl + '/api/user/user-metadata', patch, {
              headers: { Authorization: 'Bearer ' + accessToken }
            })
            .then((response) => {
              // Refresh token
              this.$auth.getTokenSilently()
              if (successCallback) {
                successCallback(response.data)
              }
            })
            .catch((error) => {
              this.showError('Failed to save, error calling API.')
              if (failCallback) {
                failCallback(error)
              }
            })
        })
        .catch(() => {
          this.showError('Failed to save, error getting auth token.')
          if (failCallback) {
            failCallback()
          }
        })
    }
  }
}
